/**
 * Vuex module for voicemail messages stack
 */
import actions from './actions'
import mutations from './mutations'
import toggle from './toggle'

const state = {
  dnd: false,
  callwaiting: false,
  intercom: {
    deskphone: false,
    callpanel: false,
    anywhere: false
  },
  callfwd: {
    enabled: false,
    number: null
  },
  followme: {
    enabled: false,
    confirm: false,
    prefix: null,
    useClientCID: false,
    timeConditionID: 0,
    timeConditions: [],
    externCID: 0,
    externCIDName: '',
    externCIDNum: '',
    strategy: 'ringall',
    toutall: 0,
    toutfirst: 0,
    markAnswered: false,
    numbers: []
  },
  blacklist: [],
  emergecyCID: {
    disabledGlobally: true,
    pID: 0,
    lID: 0,
    profiles: [],
    locations: []
  },
  ownerID: 0,
  user: {
    id: 0,
    username: '',
    firstName: '',
    lastName: '',
    email: '',
    realm: ''
  },
  subAccounts: [],
  // init with default system codes
  featureCodes: {
    dnd: '*76',
    forward: '*96', // cfwd
    followme: '*21',
    vm: '*98',
    myvm: '*97',
    recording: '*60',
    echo: '*43',
    anonymouscall: '*67',
    personalconf: '*99',
    agentlogin: '*45',
    moh: '*86',
    adhoc: '*70',
    unadhoc: '*71',
    qoffall: '*46',
    toggle: '*44',
    intercom: '*80',
    silenticom: '*81',
    call_blind_transfer: '##',
    directed_call_pickup: '**',
    on_demand_call_recording: '*1'
  },
  OTP: {
    enabled: false,
    method: '', // sms, email, qrcode
    smsAvailable: false,
    email: '',
    phoneNum: '',
    provURI: '',
    backupCodes: ''
  },
  clickToDial: {
    destination: ''
  },
  screenPop: {
    type: '',
    trigger: '',
    url: ''
  },
  showMissedCalls: false,
  clearlyAnywhereLandingPage: '/buddies',
  notifications: {
    enabled: true,
    timeout: 3000
  },
  dids: []
}

const getters = {
  dnd: state => state.dnd,
  callwaiting: state => state.callwaiting,
  intercom: state => state.intercom,
  callfwd: state => state.callfwd,
  followme: state => state.followme,
  blacklist: state => state.blacklist,
  rmq: state => state.rmq,
  eCIDProfiles: state => state.emergecyCID.profiles,
  eCIDLocations: state => state.emergecyCID.locations,
  eCIDProfileID: state => state.emergecyCID.pID,
  eCIDLocationID: state => state.emergecyCID.lID,
  eCIDDisabledGlobally: state => state.emergecyCID.disabledGlobally,
  userID: state => state.user.id,
  userEmail: state => state.user.email,
  userName: state => state.user.username,
  realm: state => state.user.realm,
  otpEnabled: state => state.OTP.enabled,
  otpMethod: state => state.OTP.method,
  otpSmsAvailable: state => state.OTP.smsAvailable,
  otpEmail: state => state.OTP.email ?? '',
  otpPhoneNum: state => state.OTP.phoneNum ?? '',
  otpProvUri: state => state.OTP.provURI,
  otpBackupCodes: state => state.OTP.backupCodes,
  otpValue: state => state.OTP.value,
  subAccounts: state => state.subAccounts,
  activeSubAccount: state => state.subAccounts.find(acc => acc.user_id === state.ownerID),
  ownerID: state => state.ownerID,
  currentUserExten: (state, getters, rootGetters) => getters.isOwnerCurUser ? rootGetters.sipua.exten : getters.activeSubAccount.username,
  isOwnerCurUser: state => state.ownerID === state.user.id,
  featureCodes: state => state.featureCodes,
  clickToDial: state => state.clickToDial,
  screenPop: state => state.screenPop,
  showMissedCalls: state => state.showMissedCalls,
  notifications: state => state.notifications,
  dids: state => state.dids,
  clearlyAnywhereLandingPage: state => state.clearlyAnywhereLandingPage
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  modules: { toggle }
}
